import type { Size } from "@repo/ui/helpers/helpers";
import type { FC } from "react";
import { GradingPassRatePill } from "./gradingPassRatePill.js";

export interface GradingPassRateProps {
  size: Size;
  passRate: number | undefined;
  isLoading?: boolean;
}

export const GradingPassRate: FC<GradingPassRateProps> = (props) => {
  return (
    <span className="inline-flex items-baseline gap-2">
      <GradingPassRatePill
        size={props.size}
        passRate={props.passRate}
        isLoading={props.isLoading}
      />
    </span>
  );
};
